import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import { connect } from 'react-redux'
import { toastr } from 'react-redux-toastr'
import { Dropdown } from 'react-bootstrap'
import { IoIosClose } from 'react-icons/io'
import _ from 'lodash'

import UserDropdown from './UserDropdown'
import { logoutUser } from '../../../../shared/api/action/AccountActions'
import { getCompaniesList, getPartnerCompaniesList } from '../../../../shared/api/action/CompaniesActions'
import { addAuditLog } from '../../../../shared/api/action/ClientActions'
import { userIcon } from '../helpers/iconHelpers'
import { useAuth } from "../../../../app/providers/AuthContext";
import { useTranslation } from 'react-i18next';

import '../../../../app/layout/HeaderNav.sass'
import './NotificationsMenu.sass'

const UserAccountMenu = (props) => {
	const navigate = useNavigate();
	const { logout } = useAuth();
	const { t } = useTranslation('translation', { keyPrefix: 'components.headerNav' });
	const {
		user, partnerList, updateCompanyList, updatePartnerList, updateCompany,
		updateCompanyCollection, partnerPortalRedirect, updatePartnerPortalRedirect,
		fullscreen, triggerClassName, triggerIcon, onOpenChange,
	} = props
	const userRole = user.roles[0];

	const [company_name, setCompany_name] = useState('');
	const [partner_company_name, setPartner_company_name] = useState('');
	const [userDropdownOpen, setUserDropdownOpen] = useState(false);

	useEffect(() => {
		let { partner_company_name, company_id, company_name, company_type, company_driver_recognition, company_token, roles, company_data } = user;
		let partnerLocal = localStorage.getItem("partner_company_name");
		let companyLocal = localStorage.getItem("company_name");
		if (!!partnerLocal === true) partner_company_name = partnerLocal;
		if (!!companyLocal === true) company_name = companyLocal;
		changeCompany(company_name, partner_company_name);

		switch (userRole) {
			case 'system_admin':
			case 'customer_service':
			case 'sales_demo':
				getPartners()
				getPartnersCompanies(partner_company_name)
				break
			case 'installer':
				getPartners()
				getPartnersCompanies()
				break
			case 'partner':
			case 'custom_partner':
				getCompanies()
				break
			case 'fleet_maintainer':
			case 'fleet_manager':
			case 'group_manager':
			case 'user':
			case 'storage_manager':
			case 'storage_user':
			case 'custom_user':
				updateCompany({
					partner: partner_company_name,
					company_id,
					name: company_name,
					type: company_type,
					driver_recognition: company_driver_recognition,
					token: company_token,
					company_data,
				})
				break
			case 'partner_view':
				getCompanies()
				break
			default:
				break
		}
	}, []);

	const getPartners = (callback) => {
		const companyType = 'PARTNER';

		getCompaniesList(userRole, companyType)
			.then((res, err) => {
				const companies = _.sortBy(res.data.response['companies list'], num => num.toLowerCase());
				const filtered_companies = filterName(companies);

				updatePartnerList(filtered_companies);

				if (callback && typeof callback === 'function') {
					callback();
				}
			})
			.catch((error) => {
				console.log('!getCompaniesList error:', error);
				toastr.error(t('issueGettingCompanies'));
			});
	}

	const filterName = (companies) => {
		return _.filter(companies.map(item => item.trim()), (num) => num !== '')
	}

	const getPartnersCompanies = (partnerCompanyNameArg, companyNameArg = '') => {
		getPartnerCompaniesList(userRole, partnerCompanyNameArg, true)
			.then((res, err) => {
				let companiesList = res.data.response['companies list'];
				let companies;
				if (companiesList[0]) {
					companiesList = _.sortBy(_.filter(companiesList.map(item => ({
						name: item.name.trim(),
						type: item.type,
						id: item.id,
						driver_recognition: item.driver_recognition,
						token: item.token,
						company_data: item.company_data,
					})), num => num.name !== ''), num => num.name.toLowerCase())

					if (companiesList.length) {
						companies = _.map(companiesList, 'name')
					}
				} else {
					companies = [];
				}

				let i = 0;
				let companyLocal = companyNameArg || localStorage.getItem("company_name");
				(!!companyLocal === true)
					? companiesList.forEach((item, index) => { if (item.name === companyLocal) i = index })
					: companiesList.forEach((item, index) => { if (item.name === user.company_name) i = index })

				if (partnerCompanyNameArg === user.partner_company_name) {
					updateProps(
						companiesList[i].name,
						partnerCompanyNameArg,
						companiesList[i].type,
						companiesList[i].id,
						companiesList[i].driver_recognition,
						companiesList[i].token,
						companiesList[i].company_data,
					)

					addAuditLogFunc(companiesList[i].id)
				}
				else if (!companiesList.length) {
					toastr.info(t('selectedPartnerNoCompanies'))
				}
				else {
					updateProps(
						companiesList[i].name,
						partnerCompanyNameArg,
						companiesList[i].type,
						companiesList[i].id,
						companiesList[i].driver_recognition,
						companiesList[i].token,
						companiesList[i].company_data,
					)

					addAuditLogFunc(companiesList[i].id)
				}

				updateCompanyList(companies)
				updateCompanyCollection(companiesList)
			})
			.catch((error) => {
				console.log('!getPartners error: ', error);
				toastr.error(t('issueGettingCompanies'));
			});
	}

	const updateProps = (company, partner, type, company_id, driver_recognition, company_token, company_data) => {
		updateCompany({
			partner,
			name: company,
			type,
			company_id,
			driver_recognition,
			token: company_token,
			company_data,
		})
	}

	const getCompanies = () => {
		const company_type = 'CUSTOMER'

		getCompaniesList(userRole, company_type, true)
			.then((res, err) => {
				let companies_list = res.data.response['companies list'];
				let companies
				if (companies_list[0]) {
					companies_list = _.sortBy(_.filter(companies_list.map(item => ({
						name: item.name.trim(),
						type: item.type,
						id: item.id,
						driver_recognition: item.driver_recognition,
						token: item.token,
						company_data: item.company_data,
					})), num => num.name !== ''), num => num.name.toLowerCase())

					if (companies_list.length) {
						companies = _.map(companies_list, 'name')
					}
				}
				else {
					companies = [];
				}

				let i = 0;
				let companyLocal = localStorage.getItem("company_name");
				if (!!companyLocal === true) companies_list.map((item, index) => { if (item.name === companyLocal) i = index });

				if (['partner', 'partner_view', 'custom_partner'].includes(userRole)) {
					// FWSD-4893, user was redirected to RL UI from the Partner Portal's Companies page
					if (partnerPortalRedirect.company_id && !partnerPortalRedirect.user_was_redirected) {
						const companySelected = _.find(companies_list, ['id', +partnerPortalRedirect.company_id])
						setCompany_name(companySelected.name)
						updatePartnerPortalRedirect({
							user_was_redirected: true,
						})

						updateCompany({
							name: companySelected.name,
							partner: user.company_name,
							type: companySelected.type,
							company_id: companySelected.id,
							driver_recognition: companySelected.driver_recognition,
							token: companySelected.token,
							company_data: companySelected.company_data,
						})
					} else {
						updateCompany({
							name: companies_list[i].name,
							partner: user.company_name,
							type: companies_list[i].type,
							company_id: companies_list[i].id,
							driver_recognition: companies_list[i].driver_recognition,
							token: companies_list[i].token,
							company_data: companies_list[i].company_data,
						})
					}
				}

				updateCompanyList(companies)
				updateCompanyCollection(companies_list)

			})
			.catch((error) => {
				console.log(error);

				toastr.error(t('issueGettingCompanies'));
			});
	}

	const logOut = (e) => {
		e.preventDefault()
		localStorage.removeItem("partner_company_name");
		localStorage.removeItem("company_name");
		localStorage.removeItem('language');

		logoutUser()
			.then(async res => {
				await logout();
				navigate('/login', { replace: true });
			})
			.catch((error) => {
				console.log(error);
			})
	}

	const onSelectCompany = (companyname) => {
		const companySelected = _.find(partnerList.company_collection, ['name', companyname])

		setCompany_name(companyname);
		closeMenu();

		updateCompany({
			partner: props.company.partner,
			name: companyname,
			type: companySelected.type,
			company_id: companySelected.id,
			driver_recognition: companySelected.driver_recognition,
			token: companySelected.token,
			company_data: companySelected.company_data,
		})

		addAuditLogFunc(companySelected.id)
	}

	const addAuditLogFunc = (companyId) => {
		const data = {
			action: 'select_company',
			action_data: { company_id: companyId },
		}
		addAuditLog(data)
			.then((res, err) => {

			})
			.catch((error) => {
				console.log('!addAuditLog error:', error)
			})
	}

	const changeCompany = (company_name, partner_company_name) => {
		partner_company_name && setPartner_company_name(partner_company_name);
		setCompany_name(company_name);
	}

	const closeMenu = () => {
		setUserDropdownOpen(false)
		onOpenChange && onOpenChange(false)
	}

	const menuContent = (
		<UserDropdown
			partnerList={partnerList}
			changeCompany={changeCompany}
			onSelectCompany={onSelectCompany}
			getPartnersCompanies={getPartnersCompanies}
			logOut={logOut}
			closeDropdown={closeMenu}
		/>
	)

	if (fullscreen) {
		const openPanel = () => {
			setUserDropdownOpen(true)
			onOpenChange && onOpenChange(true)
		}

		return (
			<>
				<button
					type="button"
					className={triggerClassName}
					aria-label="Profile"
					onClick={userDropdownOpen ? closeMenu : openPanel}
				>
					{triggerIcon || userIcon}
				</button>
				<div className={`mobile-fullscreen-menu ${userDropdownOpen ? 'open' : ''}`}>
					<div className="mobile-fullscreen-menu-header">
						<button
							type="button"
							className="mobile-menu-sheet-close"
							title="Close"
							onClick={closeMenu}
						>
							<IoIosClose aria-hidden="true" />
							<span className="sr-only">Close</span>
						</button>
					</div>
					<div className="user-account-menu mobile-fullscreen-menu-body">
						{menuContent}
					</div>
				</div>
			</>
		)
	}

	return (
		<Dropdown
			id="user-account-btn"
			className='user-icon-dropdown'
			pull-right="true"
			role="menuitem"
			show={userDropdownOpen}
			onToggle={isOpen => {
				setUserDropdownOpen(isOpen)
			}}
		>
			<Dropdown.Toggle
				className="dropdown-toggle user-toggle"
				bsPrefix="no-caret"
				variant="outline"
				aria-controls='user-settings-dropdown'
			>
				{userIcon}
			</Dropdown.Toggle>
			<Dropdown.Menu className="user-account-menu">
				{menuContent}
			</Dropdown.Menu>
		</Dropdown>
	)
}

const mapStateToProps = (state) => ({
	user: state.user.user,
	company: state.company.company,
	partnerList: state.partnerList,
	partnerPortalRedirect: state.partnerPortalRedirect,
})

const mapDispatchToProps = (dispatch) => ({
	updateCompany: (company) => {
		dispatch({ type: 'GET_COMPANY_SUCCESS', payload: company });
	},
	updateCompanyList: (partner) => {
		dispatch({ type: 'GET_COMPANY_LIST_SUCCESS', payload: partner });
	},
	updateCompanyCollection: (partner) => {
		dispatch({ type: 'GET_COMPANY_COLLECTION_SUCCESS', payload: partner });
	},
	updatePartnerList: (partner) => {
		dispatch({ type: 'GET_PARTNER_LIST_SUCCESS', payload: partner });
	},
	updatePartnerPortalRedirect: (payload) => {
		dispatch({ type: 'SET_PARTNER_PORTAL_REDIRECT', payload });
	},
})

export default connect(mapStateToProps, mapDispatchToProps)(UserAccountMenu);
